
<template>
  <pop-up-layout 
    :title="$t('general.misc.cambiarEntorno')"
    :aceptar="$t('general.misc.continuar')"
    :saving="waitingForLoad"
    :loadingText="$t('general.misc.cargando')"
    @volver="$parent.hide()"
    @aceptar="guardar()"
    :description="$t('general.misc.elijaEntorno')"
  >
    <v-radio-group style="padding: 18px 30px 0px;" v-model="idubapi">
      <template v-for="entorno in usuario.entornos">
        <template v-for="idubapiEntorno in entorno.idubapis">
          <v-radio
            color="primary"
            :key="idubapiEntorno.ID_BD_PRINEX"
            :label="`${entorno.descripcion} - ${idubapiEntorno.DESC_BD_PRINEX}`"
            :value="idubapiEntorno.ID_BD_PRINEX"
            class="entorno"
          >
            <v-layout slot="label">
              <v-img
                v-if="idubapiEntorno.LOGO_ENTORNO_TRABAJO !== null"
                height="64px"
                width="64px"
                style="margin-right:10px;"
                :src="'data:image;base64,' + idubapiEntorno.LOGO_ENTORNO_TRABAJO"
                class="treeNodeImage"
              ></v-img>
              <span style="line-height:64px;">{{idubapiEntorno.DESC_BD_PRINEX}}</span>
            </v-layout>
          </v-radio>
        </template>
      </template>
    </v-radio-group>
  </pop-up-layout>
</template>
<script>

import {mapGetters, mapActions} from 'vuex'

export default {
  data () {
    return {
      waitingForLoad: false,
      idubapi: null
    }
  },
  created () {
    this.idubapi = this.usuario.idubapi
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario',
    })
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      cambiarEntornoTrabajo: 'login/cambiarEntornoTrabajo'
    }),
    async guardar () {
      if (this.idubapi === this.usuario.idubapi) {
        this.$parent.hide()
      } else {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        const idEntorno = this.usuario.entornos.filter((entorno) => {
          return entorno.idubapis.map(idubapi => idubapi.ID_BD_PRINEX).includes(this.idubapi)
        })[0].id
        try {
          await this.cambiarEntornoTrabajo({
            id: idEntorno,
            idubapi: this.idubapi
          })
          // this.setPopUp(true)
          this.$parent.hide()
          this.waitingForLoad = false
          const entornoActual = this.usuario.entornos.filter((entorno) => {
            return entorno.id === this.usuario.entornoId
          })[0]
          const idubapiActual = entornoActual.idubapis.filter((idubapiEntorno) => {
            return idubapiEntorno.ID_BD_PRINEX === this.usuario.idubapi
          })[0]
          this.addAlert({texto: this.$t('general.misc.entornoHaCambiado', {entorno: idubapiActual.DESC_BD_PRINEX}), color: 'success'})
          this.$router.push({ name: 'home' })
        } catch (error) {
          if (!error.code || error.code !== 1) {
            this.addAlert({texto: error.message, color: 'error'})
          }
          this.$parent.hide()
          this.waitingForLoad = false
          this.$parent.noCerrarInterno = false
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/EntornoCambiar.vue